import { rupees } from './format';
import type { EarnedReward, RewardValue } from './types';

/**
 * What a rider reward takes off a fare, as the server does it at booking (docs/API.md "Rewards (rider)"):
 * a credit comes off up to the fare; a percentage is capped at maxPaise; both in whole rupees.
 */
export function rewardOff(r: RewardValue, farePaise: number): number {
  let off = 0;
  if (r.kind === 'RIDER_RIDE_CREDIT') off = Math.min(r.amountPaise ?? 0, farePaise);
  else if (r.kind === 'RIDER_DISCOUNT_PERCENT') off = Math.min(Math.round((farePaise * (r.percent ?? 0)) / 100), r.maxPaise ?? Infinity, farePaise);
  return Math.floor(off / 100) * 100;
}

/** "₹20" or "10%" — the short value of a reward. */
export const rewardValue = (r: RewardValue) => (r.kind === 'RIDER_DISCOUNT_PERCENT' ? `${r.percent ?? 0}%` : rupees(r.amountPaise ?? 0));

/** The best AVAILABLE reward for this fare (largest discount), or null. */
export function bestReward(available: EarnedReward[], farePaise: number): EarnedReward | null {
  const usable = available.filter((r) => r.status === 'AVAILABLE' && rewardOff(r, farePaise) > 0);
  return usable.sort((a, b) => rewardOff(b, farePaise) - rewardOff(a, farePaise))[0] ?? null;
}
